import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { SHARED_CONSTANTS_AUTO_STOP_EXEMPTION_ERROR } from "@lib/shared_constants";

export interface PatchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionProps {
  appGroupId: string;
  campaignId: string;
  neverAutoStop: boolean;
  /**
   * The changelog the caller loaded the campaign with; the backend refuses the write if it has moved since.
   * Sent as an empty string when the campaign had none yet, so a changelog created in the meantime still conflicts.
   */
  activeChangelogId?: string;
}

export interface PatchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionResult {
  id: string;
  never_auto_stop: boolean;
  active_changelog_id: string;
}

export type AutoStopExemptionDisabledError = FetchUserEncodedError<
  SHARED_CONSTANTS_AUTO_STOP_EXEMPTION_ERROR["DISABLED"]
>;
export type AutoStopExemptionInvalidParamsError = FetchUserEncodedError<
  SHARED_CONSTANTS_AUTO_STOP_EXEMPTION_ERROR["INVALID_PARAMS"]
>;
export type AutoStopExemptionLimitReachedError = FetchUserEncodedError<
  SHARED_CONSTANTS_AUTO_STOP_EXEMPTION_ERROR["LIMIT_REACHED"],
  { limit: number }
>;
export type AutoStopExemptionNotFoundError = FetchUserEncodedError<
  SHARED_CONSTANTS_AUTO_STOP_EXEMPTION_ERROR["NOT_FOUND"]
>;
export type AutoStopExemptionNotEligibleError = FetchUserEncodedError<
  SHARED_CONSTANTS_AUTO_STOP_EXEMPTION_ERROR["NOT_ELIGIBLE"]
>;
export type AutoStopExemptionStaleVersionError = FetchUserEncodedError<
  SHARED_CONSTANTS_AUTO_STOP_EXEMPTION_ERROR["STALE_VERSION"]
>;

export type PatchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionResultErrors =
  | AutoStopExemptionDisabledError
  | AutoStopExemptionInvalidParamsError
  | AutoStopExemptionLimitReachedError
  | AutoStopExemptionNotFoundError
  | AutoStopExemptionNotEligibleError
  | AutoStopExemptionStaleVersionError;

export const isPatchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionResultError = (
  error: FetchRequestError
): error is PatchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionResultErrors => {
  return error instanceof FetchUserEncodedError;
};
